import PropTypes from 'prop-types';
import React from 'react';
import { DangerousHTMLDiv } from '../../DangerousHTML/DangerousHTMLDiv';

export class RadioButton extends React.Component {
  onRadioCheckboxChange = (event) => {
    let val = event.target.value;
    if (!isNaN(val)) {
      val = parseInt(event.target.value, 10);
    }
    this.props.onChange(val);
  }

  render = () => {
    const { listAnswerItem } = this.props;

    return (
      <div className="radio cell">
        <div className="form-check">
            <input type="radio" name={'optionsRadioCheckbox' + listAnswerItem.questionnaireItemId}
              value={listAnswerItem.listAnswerId} onChange={this.onRadioCheckboxChange}
              disabled={this.props.disabled}
              checked={this.props.answerItem &&
                this.props.answerItem.listAnswerId === listAnswerItem.listAnswerId}
              className="form-check-input border border-black float-none ms-0 me-2 me-lg-0"
            />
            <label className="form-check-label d-lg-none">
              <DangerousHTMLDiv html={listAnswerItem.formattedText} />
            </label>
        </div>
      </div>
    );
  }
}

RadioButton.propTypes = {
  listAnswerItem: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.object,
};
